import { cliente } from '@/lib/cliente';
import { useQuery } from '@tanstack/react-query';

/**
 * Matriz de avance (vista "Por Costos"): obras en ejecución × partidas.
 * Sin proyecto (null = "Todos") incluye todas las obras en ejecución.
 */
export function useMatriz(proyecto: string | null, bloque?: string, semana?: number | null) {
  return useQuery({
    queryKey: ['matriz', proyecto, bloque ?? null, semana ?? null],
    queryFn: () => cliente.obras.matriz(proyecto, bloque, semana),
    // Consulta pesada (toca vw_obras). Cacheamos para no re-pedirla al navegar;
    // las mutaciones de avance la marcan stale (refetchType:'none').
    staleTime: 60_000,
  });
}
